// Route modules
import lab from './lab';
import settings from './settings';
import teleconsult from './teleconsult';
import emr from './emr';
import bpdata from './bpdata';
import workingCalendar from './workingCalendar';
import appointment from './appointment';
import home from './home';
import prescription from './prescription';
// import management from './management';
// import patients from './patients';
import common from './common';

const concat = (...args) => args.reduce((acc, val) => [...acc, ...val]);

const routes = concat(
  // management,
  lab,
  settings,
  teleconsult,
  emr,
  bpdata,
  workingCalendar,
  appointment,
  home,
  prescription,
  // patients,
);

export { common };

export default routes;
